import Vue from 'vue';

Vue.component('fnb-audit-trail-index', () =>
    import(/* webpackChunkName: 'index' */ './audit-trail-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/audit-trail/index.js